import type { SmartViewArtifact } from "../../../../../api/types/smartViewArtifactsTypes";

export interface ArtifactStatus {
  label: string;
  tone: "published" | "changes" | "draft";
}

export const getArtifactStatus = ({
  publishedVersion,
  latestVersion,
}: Pick<SmartViewArtifact, "publishedVersion" | "latestVersion">): ArtifactStatus => {
  if (!publishedVersion) {
    return { label: "Draft", tone: "draft" };
  }
  return latestVersion > publishedVersion
    ? { label: "Unpublished changes", tone: "changes" }
    : { label: `Published · v${publishedVersion}`, tone: "published" };
};
